import { gql } from '@apollo/client';

export const GENERATE_REPORT_DATA = gql`
  query GenerateReportData($input: GenerateReportInput!) {
    generateReportData(input: $input) {
      ... on ReportDataResponse {
        teamMembers {
          teamMemberId
          teamMemberName
          teamMemberRole
          isContractor
          jobsCount
          totalPayout
          totalBilledAmount
          weeklySalary
          calculatedSalaryPayout
          usesSalaryCalculation
          salaryCalculationMethod
          daysWorked
          fullWeeks
          partialDays
          dailyRate
          jobs {
            job {
              id
              status
              scheduledDate
              updatedAt
              notes
              isEarlyCheckin
              isLateCheckout
              isOwnerBlock
              isMaintenanceBlock
              property {
                id
                name
                address
                propertyCode
                area
              }
              serviceType {
                id
                title
                usePropertyFinancialFields
              }
              assignedTo {
                id
                firstName
                lastName
              }
            }
            calculatedPayout
            calculatedBilledAmount
            isPayoutOverridden
            isBilledAmountOverridden
            customPayout
            customBilledAmount
          }
        }
        grandTotalPayout
        grandTotalBilledAmount
        totalExpenses
        finalTotal
        totalJobs
        appliedRoleFilter
        payrollAppliedAreas: appliedAreas
      }
      ... on WorkOrderReportDataResponse {
        workOrders {
          id
          description
          status
          isUrgent
          isFeedback
          propertyName
          propertyArea
          propertyCode
          quickbooksCustomerId
          customerName
          assignedDepartment
          assignedToName
          submittedByName
          submittedAt
          completedAt
          dueDate
          totalExpenses
          totalBaseCost
          totalBilledAmount
          totalProfit
          commentCount
          urgentCommentCount
          isExcludedFromInvoicing
          isLaborUnbillable
          isServiceChargeEnabled
          serviceChargeAmount
          editedTotalTimeMinutes
          comments {
            id
            comment
            isEscalation
            attachments
            createdAt
            userName
            userRole
          }
          expenses {
            id
            title
            baseCost
            billedAmount
            isBillable
            createdAt
            createdByName
          }
          totalTimeWorkedMinutes
          billableHours
          laborCharge
          timeEntries {
            id
            durationMinutes
            workerName
            createdAt
          }
        }
        summary {
          totalWorkOrders
          completedCount
          openCount
          inProgressCount
          canceledCount
          urgentCount
          feedbackCount
          grandTotalBaseCost
          grandTotalBilledAmount
          grandTotalProfit
          workOrdersByDepartment {
            department
            count
            totalBaseCost
            totalBilledAmount
            totalProfit
          }
          workOrdersByArea {
            area
            count
            totalBaseCost
            totalBilledAmount
            totalProfit
          }
          averageCompletionTimeHours
          serviceChargeHourlyRate
          totalTimeWorkedMinutes
          totalBillableHours
          totalLaborCharge
        }
        appliedAreas
        appliedDepartments
        appliedStatuses
        appliedCustomerIds
        appliedPropertyIds
      }
    }
  }
`;

export const GET_REPORTS = gql`
  query GetReports {
    reports {
      id
      name
      type
      startDate
      endDate
      status
      roleFilter
      totalPayout
      totalCost
      totalExpenses
      finalTotal
      jobsCount
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_REPORT = gql`
  query GetReport($id: String!) {
    report(id: $id) {
      id
      name
      type
      startDate
      endDate
      status
      roleFilter
      reportDataJson
      reportFilePath
      reportFileSize
      totalPayout
      totalCost
      totalExpenses
      finalTotal
      jobsCount
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
      expenses {
        id
        description
        amount
        createdAt
      }
    }
  }
`;

export const CREATE_REPORT = gql`
  mutation CreateReport($input: CreateReportInput!) {
    createReport(input: $input) {
      id
      name
      type
      startDate
      endDate
      status
      createdAt
    }
  }
`;

export const UPDATE_REPORT = gql`
  mutation UpdateReport($id: String!, $input: UpdateReportInput!) {
    updateReport(id: $id, input: $input) {
      id
      name
      type
      startDate
      endDate
      status
      updatedAt
    }
  }
`;

export const SAVE_REPORT_DATA = gql`
  mutation SaveReportData($input: SaveReportDataInput!) {
    saveReportData(input: $input) {
      id
      name
      type
      startDate
      endDate
      status
      totalPayout
      totalCost
      totalExpenses
      finalTotal
      jobsCount
      createdAt
    }
  }
`;

export const UPDATE_REPORT_NAME = gql`
  mutation UpdateReportName($input: UpdateReportNameInput!) {
    updateReportName(input: $input) {
      id
      name
      type
      startDate
      endDate
      status
      createdAt
    }
  }
`;

export const DELETE_REPORT = gql`
  mutation DeleteReport($id: String!) {
    deleteReport(id: $id)
  }
`;

export const GET_PUBLIC_REPORT = gql`
  query GetPublicReport($id: ID!, $token: String) {
    publicReport(id: $id, token: $token) {
      id
      name
      type
      startDate
      endDate
      status
      roleFilter
      reportDataJson
      reportFilePath
      reportFileSize
      totalPayout
      totalCost
      totalExpenses
      finalTotal
      jobsCount
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
      expenses {
        id
        description
        amount
        createdAt
      }
    }
  }
`;

export const GENERATE_REPORT_SHARE_TOKEN = gql`
  mutation GenerateReportShareToken($input: GenerateReportShareTokenInput!) {
    generateReportShareToken(input: $input) {
      token
      expiresAt
    }
  }
`; 